import React from 'react';
import PropTypes from 'prop-types';

const SubscriptionPageLayout = ({ title, children, footer }) => (
  <div className="container subscription-page">
    <div className="grid grid-gap-20">
      <div className="col-12">
        <h1 className="subscription-page__title">{title}</h1>
      </div>
      <div className="col-12">
        <div className="subscription-page__body subscription-page__invoice">
          {children}
        </div>
      </div>
      <div className="col-12 subscription-page__footer">{footer}</div>
    </div>
  </div>
);

SubscriptionPageLayout.defaultProps = {
  title: null,
  children: null,
  footer: null,
};

SubscriptionPageLayout.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  footer: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default SubscriptionPageLayout;
